import { render } from "./Split.vue?vue&type=template&id=edac2eaa"
import script from "./Split.vue?vue&type=script&lang=js"
export * from "./Split.vue?vue&type=script&lang=js"

import "./Split.vue?vue&type=style&index=0&id=edac2eaa&lang=css"
script.render = render

export default script